// extracted by mini-css-extract-plugin
export default {"container":"OfferFilterPanelCheckboxSection_container__xhJxz","checkboxesContainer":"OfferFilterPanelCheckboxSection_checkboxesContainer__NCpa7"};